<ng-container *ngIf="!item.isParent() || item.flag === 'corporative'; else itemNoLink">
  <ng-container *ngIf="item.flag === 'corporative' else linkNoInterchain">
    <a class="navbar_item full_link" (click)="handleInterchainClicked()" [routerLink]="interchainLink" routerLinkActive="active" #rlaInterchain="routerLinkActive">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { isActive: rlaInterchain.isActive }"></ng-container>
    </a>
  </ng-container>
</ng-container>

<ng-template #linkNoInterchain>
  <a class="navbar_item full_link" (click)="changeRoute()" routerLink="{{item.link}}" routerLinkActive="active" #rla="routerLinkActive">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { isActive: rla.isActive }"></ng-container>
  </a>

</ng-template>

<ng-template #itemNoLink>
  <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
</ng-template>


<ng-template #itemTemplate let-isActive="isActive">
  <div
    class="item_menu depth_{{item.depth}}"
    [class.plg-item]="isPlgItem"
    [class.active]="isActive || isNodeActive"
    [class.notLink]="item.isParent()"
    [class.depth_0_collapse]="sideBarCollapsed && item.depth === 0"
    [class.config]="statusNavbar === 1"
    [class.managers]="statusNavbar === 2"
    [attr.role]="item.isParent() ? 'button' : null"
    (click)="utilService.toggleNavbar(false); handleSpecialNavigation (item)"
  >
    <div class="icon" *ngIf="statusNavbar !== 1" [ngClass]="{ 'tw-text-left': !sideBarCollapsed, 'tw-text-center': sideBarCollapsed }">
      <mat-icon *ngIf="item.matIcon">{{item.icon}}</mat-icon>
      <i *ngIf="!item.matIcon" class="{{item.icon}}"></i>
    </div>
    <div class="name_item" [class.config]="statusNavbar === 1" [class.selected]="item.flag === 'home' && router.url.includes('dashboard') || item.flag === 'corporative' && statusNavbar === 3" *ngIf="!sideBarCollapsed">
      {{'navbar.product.'+type+'.'+item.name | translate }}
    </div>

    <div class="tag-label beta" *ngIf="item.beta && !sideBarCollapsed" >
      {{ 'commons.beta' | translate }}
    </div>

    <div class="tag-label new tw-uppercase" *ngIf="item.new && !sideBarCollapsed">
      {{ 'commons.new_tag' | translate  }}
    </div>

    <div class="tag-label superadmin" *ngIf="item.superAdmin && item.children.length === 0 && !sideBarCollapsed">
        &nbsp;
    </div>
  </div>
</ng-template>
